import React, {
    useState,
    useEffect,
    useContext,
    forwardRef,
    useImperativeHandle,
    useRef,
  } from 'react'
  import axios from 'axios'
  import {
    Table,
    Popover,
    Whisper,
    Checkbox,
    Dropdown,
    IconButton,
    Progress,
    Rate
  } from 'rsuite';
  import { Link } from 'react-router-dom';
  import {Tabs,Tab} from "react-bootstrap"
  import Modal from 'react-bootstrap/Modal';
  import Form from 'react-bootstrap/Form';
  import { Row, Col } from 'react-bootstrap'
  import {
    formatDate,
    parseResponseJSON,
    logMe,
    getDataSorted,
    formatDateText,
    dateDifference
  } from './CommonFunctions'
import { useParams } from 'react-router-dom';
import Header from './Header';
import { Grid,Button, Box } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import EditDeposit from './CashManagement/EditDeposit';
import { NumericFormat } from 'react-number-format';
import { rowsMetaStateInitializer } from '@mui/x-data-grid/internals';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
  const { Column, HeaderCell, Cell } = Table;
const thisMonth=new Date();
thisMonth.setDate(1);
  const DepositReport = (props) => {
    const url = process.env.REACT_APP_SERVER_URL;
    const [depositDetails,setDepositDetails]=useState([])
    const [searchStartDate,setSearchStartDate]=useState(formatDate(thisMonth));
    const [searchEndDate,setSearchEndDate]=useState(formatDate(new Date(),1));
    const [showDepositedPayments, setShowDepositedPayments] = useState(false);
    const [currentDeposit,setCurrentDeposit] = useState({})
    const [filteredRows,setFilteredRows] = useState([]);
    useEffect(() => {
      getAllDeposits();
      }, []);
    
    const filterRowsBySearchDates = (depositDetails,searchStartDate,searchEndDate) =>{
      const filtered = depositDetails.filter((row)=>{
        if(row.depositDate>=searchStartDate && row.depositDate<=searchEndDate)
          return row;
      })
      console.log(filtered)
      setFilteredRows(filtered)
    }


    const getAllDeposits = async() => {
        try{
            await axios.get(`${url}/cashDeposits`).then((responseForDeposits)=>{
                console.log(responseForDeposits.data);
                setDepositDetails(responseForDeposits.data);
        filterRowsBySearchDates(responseForDeposits.data,searchStartDate,searchEndDate);

            })

        }catch(error){
            console.log(error);
        }
      }
      const searchDepositsByDateRange = async(searchStartDate,searchEndDate)=>{
        try{
          console.log("Search Deposits By Date Range. Search Start Date : " + searchStartDate)

        }
        catch(error){
          console.log(error);
        }
      }

    const columns=[
      { field: `id`, headerName: 'Deposit Id', width: 120, align: 'left' ,
        renderCell:(params)=>{
        const currentRow=params.row;
        return <Link onClick={(e)=>{
          setCurrentDeposit(currentRow);
          setShowDepositedPayments(true);
        }}>{currentRow.id}</Link>
      } },
      { field: 'depositDate', headerName: 'Deposit Date', width: 180, align: 'left' ,
        renderCell:(params)=>{
          const currentRow=params.row;
          return currentRow.depositDate ? 
          formatDateText(currentRow.depositDate) : null;       
                    
      } },
      { field: 'depositedBy', headerName: 'Deposited By', width: 120, align: 'left' },
      { field: 'amount', headerName: 'Deposited Amount', width: 120, align: 'left',
        renderCell:(params)=>{
        const currentRow=params.row;
          return <NumericFormat value={currentRow.amount} 
              thousandSeparator prefix={'$'} displayType="text"/>
        }
       },
      { field: 'expectedAmount', headerName: 'Expected Amount to be Deposited', width: 120, align: 'left',
        renderCell:(params)=>{
          const currentRow=params.row;
            return <NumericFormat value={currentRow.expectedAmount} 
                thousandSeparator prefix={'$'} displayType="text"/>
          }
       },
      { field: 'diff', headerName: 'Difference', width: 120, align: 'left',
        renderCell:(params)=>{
          const currentRow=params.row;
            return <NumericFormat value={currentRow.amount-currentRow.expectedAmount} 
                thousandSeparator prefix={'$'} displayType="text"/>
          }
       },
      
      { field: 'bankName', headerName: 'Bank Details', width: 180, align: 'left' },
      { field: 'remarks', headerName: 'Remarks', width: 280, align: 'left' },
         
    ];

    return (
        <>
        <Header/>
        {/* <br></br> */}
        <Grid container spacing={2} sx={{m: 1}}>
        <Grid item xs={12} sm={12} md={2}></Grid>
        <Grid item xs={12} sm={12} md={2.5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker 
                defaultValue={dayjs(searchStartDate)} 
                label="Start Date"
                // views={['year', 'month', 'day']}
                onChange={(value) => {
                  const formattedDate = value ? value.format('YYYY-MM-DD') : null;
                  console.log(formattedDate);
                  setSearchStartDate(formattedDate);
                }}
              />
            </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={2.5}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                defaultValue={dayjs(searchEndDate)} 
                label="End Date"
                // views={['year', 'month', 'day']}
                onChange={(value) => {
                  const formattedDate = value ? value.format('YYYY-MM-DD') : null;
                  console.log(formattedDate);
                  setSearchEndDate(formattedDate);
                }}
              />
            </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={12} md={2.5}>
              <Button 
              onClick={(e)=>filterRowsBySearchDates(depositDetails,searchStartDate,searchEndDate)}>SEARCH</Button>
            </Grid>
            <Grid item xs={12} sm={12} md={2.5}></Grid>
          </Grid>
        <br></br>

        <Box
        sx={{
          height: '28.5rem',
          width: '90%',
          '& .actions': {
            color: 'text.secondary',
          },
          '& .textPrimary': {
            color: 'text.primary',
          },
          marginLeft:"5%",
          marginRight:"5%",
          backgroundColor: "#fff",
          borderRadius:"4.2px",
          boxShadow:"0px 3px 10px -2px rgba(0, 0, 0, 0.2)"
        }}
      >
        <DataGrid rows={filteredRows} columns={columns} getRowHeight={() => 'auto'} 
        getRowId={(row) => row.id} 
        sx={{
          [`& .${gridClasses.cell}`]: {
          py: 1.5,
          fontSize: '0.96rem',
          },
        }}
        
        />
        
      </Box> 
      {/* <div class="container">

        <Table autoHeight data={filteredRows} id="table">

      <Column width={100} fixed sortable>
        <HeaderCell><b style={{color:"black"}}>Deposit Id</b></HeaderCell>
        <Cell dataKey="id">
          {rowData => {
            return <Link onClick={(e)=>{
              setCurrentDeposit(rowData);
              setShowDepositedPayments(true);
            }}>{rowData.id}</Link>
            
          }}
          </Cell>
      </Column>
      <Column width={180} sortable>
        <HeaderCell><b>Deposit Date</b> </HeaderCell>
        <Cell dataKey="depositDate">
        {rowData => (
          <>
            {formatDateText(rowData.depositDate)}
          </>
            
          )}
        
        </Cell>
      </Column>

      

      

      <Column width={150}>
        <HeaderCell><b>Deposited By </b></HeaderCell>
        <Cell dataKey="depositedBy" />
      </Column>

      <Column width={120} sortable>
        <HeaderCell><b>Amount Deposited</b></HeaderCell>
        <Cell dataKey="amount">
        {rowData => (
            <NumericFormat value={rowData.amount} 
            thousandSeparator prefix={'$'} displayType="text"/>
            
          )}
        
        </Cell>
      </Column>
      <Column width={120} sortable>
        <HeaderCell><b>Expected Amount to be Deposited</b></HeaderCell>
        <Cell dataKey="expectedAmount">
        {rowData => (
            <NumericFormat value={rowData.expectedAmount} 
            thousandSeparator prefix={'$'} displayType="text"/>
            
          )}
        </Cell>
      </Column><Column width={120} sortable>
        <HeaderCell><b>Difference</b></HeaderCell>
        <Cell dataKey="amount">
        {rowData => (
            <NumericFormat value={rowData.amount-rowData.expectedAmount} 
              thousandSeparator prefix={'$'} displayType="text"/>
            
          )}
        </Cell>
      </Column>
      <Column width={120} sortable>
        <HeaderCell><b>Bank Name </b></HeaderCell>
        <Cell dataKey="bankName">
        </Cell>
      </Column>

      <Column width={240} sortable>
        <HeaderCell><b>Remarks </b></HeaderCell>
        <Cell dataKey="remarks" />
      </Column>

     


     
      

        </Table> */}
        {showDepositedPayments && <EditDeposit currentDeposit={currentDeposit}
        showDepositedPayments={showDepositedPayments} setShowDepositedPayments={setShowDepositedPayments}/>} 
        {/* </div> */}
        </>

    );
    
}
export default DepositReport;